import { post } from "@/utils/request";
import { BASE_URL } from '@/services/api.js'

/**
 * 请求密匙
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function menuKey(params) {
    return post(`${BASE_URL}/ext/key`, params)
}

/**
 * 请求字典
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function dropLists(params) {
    return post(`${BASE_URL}/ext/dict/data/values`, params)
}
